import { initializeApp, FirebaseApp } from 'firebase/app'
import {
	getAnalytics,
	isSupported,
	logEvent as fbLogEvent,
	Analytics
} from 'firebase/analytics'

const firebaseConfig = {
	apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
	authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
	projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
	storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '',
	messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
	appId: process.env.REACT_APP_FIREBASE_APP_ID || '',
	measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || ''
}

const hasConfig = !!firebaseConfig.apiKey && !!firebaseConfig.projectId

let firebaseApp: FirebaseApp | null = null
let analytics: Analytics | null = null

if (hasConfig) {
	firebaseApp = initializeApp(firebaseConfig)
	isSupported()
		.then(supported => {
			if (supported && firebaseApp) {
				analytics = getAnalytics(firebaseApp)
			}
		})
		.catch(() => {
			// analytics unsupported in this environment (e.g. SSR, in-app browsers)
		})
}

export const logEvent = (
	name: string,
	params?: Record<string, string | number | boolean | undefined>
): void => {
	if (analytics) fbLogEvent(analytics, name as any, params)
}

export const setPageView = (pathname: string, title?: string): void => {
	if (!analytics) return
	fbLogEvent(analytics, 'page_view', {
		page_path: pathname,
		page_title: title || document.title,
		page_location: window.location.href
	})
}

export { firebaseApp, analytics }
